/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useReportsService} from "../../../../../services/reportsService";


/* Components */
import SelectBookingDates from "../../../../selectBookingDates";
import UCButton from "../../../../buttons";
import { ReactComponent as DownloadIcon } from "../../../../../resources/images/download-02.svg";
import UCSelect from "../../../../ucselect";
import { useUserContext } from "../../../../../contexts/userContext";
import { AIRLINES } from "../../../../../constants/appConstants";

/* Styles */
import styles, {customSelectStyles}from "./styles.js"
import {colors} from "../../../../../constants/colors";

const messages = defineMessages({
  yearToDateLabel: {
    id: "bookings.filters.yearToDate"
  },
  travelDateLabel: {
    id: "bookings.filters.allTime"
  },
  downloadTravelCSV: {
    id: "receipts.button"
  },
})

const BookingFilters = ({gridOptions, setGridOptions, enableDownloadButton}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const intl = useIntl();

  const { downloadBookings, getSuppliersByCompany } = useReportsService();
  const [showBookingOverlay, setShowBookingOverlay] = useState(false)
  const [showTravelOverlay, setShowTrevelsOverlay] = useState(false)
  const [airlineOptions, setAirlineOptions] = useState([])

  const handleDownload = () => {
    downloadBookings(gridOptions)
  }

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

useEffect(() => {
    const fetchSuppliers = async () => {
      const data = await getSuppliersByCompany();
      if (data?.suppliers) {
        const allAirlinesOption = {
          value: '',
          label: <FormattedMessage id="reports.provider.all" />,
        };
        const supplierOptions = data.suppliers.map((s) => ({
          value: s.providerEntityID,
          label: <FormattedMessage id={`reports.provider.${s.providerCode}`} />,
        }));
        setAirlineOptions([allAirlinesOption, ...supplierOptions]);
      }
    };
    fetchSuppliers();
  }, []);
  return (
    <div className={classes.filters}>
      <div className={classes.filterButtons}>
        {providerCode === AIRLINES.UC && (
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="reports.airline.label" />
            </p>
            <UCSelect
              className={classes.airlines}
              styles={customSelectStyles}
              displayName={<FormattedMessage id="reports.provider.all" />}
              options={airlineOptions}
              defaultValue={{
                value: '',
                label: <FormattedMessage id="reports.provider.all" />,
              }}
              onChange={(item) =>
                setGridOptions({
                  ...gridOptions,
                  page: 1,
                  providerEntityId: item.value,
                })
              }
            />
          </div>
        )}
        <div className={classes.filterDates}>
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="bookings.filters.bookingDate" />
            </p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.yearToDateLabel)}
              defaultValue="yearToDate"
              id={'booking'}
              showOverlay={showBookingOverlay}
              setShowOverlay={setShowBookingOverlay}
            />
          </div>
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="bookings.filters.travelDate" />
            </p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.travelDateLabel)}
              defaultValue="allTime"
              id={'travel'}
              showOverlay={showTravelOverlay}
              setShowOverlay={setShowTrevelsOverlay}
            />
          </div>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <UCButton
          type="primary"
          className={classes.button}
          onClick={handleDownload}
          text={<FormattedMessage id="receipts.button" />}
          icon={<DownloadIcon />}
          disabled={!enableDownloadButton}
          loadingStateStyling={classes.downloadCsvLoadingState}
          ariaLabel={intl.formatMessage(messages.downloadTravelCSV)}
          tabIndex={0}
          spinner={{
            name: 'downloadBookingsSpinner',
            size: 20,
          }}
        />
      </div>
    </div>
  );
}

export default BookingFilters;
